import styled, { css } from 'styled-components';

import { breakpoints, Button } from '@notino/react-styleguide';

export const Container = styled.div<{ newDesign: boolean }>`
  width: 100%;

  ${({ newDesign }) =>
    newDesign &&
    css`
      @media (min-width: ${breakpoints.lg}) {
        padding-bottom: 2rem;
      }
    `}
`;

export const ButtonsWrapper = styled.div<{ canBuy?: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ canBuy }) =>
    canBuy &&
    css`
      @media (min-width: ${breakpoints.lg}) {
        flex-direction: row;
      }
    `}
`;

export const LeftIconWrapper = styled.div`
  align-self: flex-start;
  padding-right: 1rem;
  width: 2.25rem;
  line-height: 0;
`;

export const StyledWatchdogButton = styled(Button)`
  text-transform: none !important;
  font-weight: normal !important;
`;

export const WatchdogWrapper = styled.div`
  text-align: center;
  align-self: flex-start;

  @media (min-width: ${breakpoints.md}) {
    text-align: left;
  }
`;

export const DiscountWrapper = styled.div<{ newDesign: boolean }>`
  margin-top: 0.75rem;
  ${({ newDesign }) =>
    newDesign &&
    css`
      margin-top: 0.75rem;
    `}
`;

export const TryItOnButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  padding: 0.625rem 1.5rem;
`;

export const FaceButtonsWrapper = styled.div<{
  isNewAlternatedTryItOnState: boolean;
  shouldShowTryItOnButton: boolean;
}>`
  display: flex;
  flex-direction: ${({ isNewAlternatedTryItOnState }) =>
    isNewAlternatedTryItOnState ? 'column-reverse' : 'column'};
  gap: 1rem;

  margin: 1rem 0;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: ${({ isNewAlternatedTryItOnState }) =>
      isNewAlternatedTryItOnState ? 'row-reverse' : 'row'};
    justify-content: start;
    margin: 0.75rem 0;
    gap: 0.75rem;
  }

  ${({ shouldShowTryItOnButton }) =>
    !shouldShowTryItOnButton &&
    css`
      margin: 0 !important;
    `}
`;
